import { PROJECT_MEDIA_TYPES } from 'consts'
import { IMediaItem, MediaStatus } from 'types/media'

export const checkIfAIVideoIsGenerating = (item: IMediaItem) => {
  const isAIVideo =
    item.type === PROJECT_MEDIA_TYPES.aiVideo &&
    item.meta.status === MediaStatus.PENDING &&
    item.id

  return !!isAIVideo
}
